(() => {
	angular.module('main').directive('spinningWheel', spinningWheel);

	function spinningWheel() {
		return {
			restrict: 'A',
			scope: {
				isSpinningWheelActive: '=',
				isSpinningWheelAfter: '@',
				isSpinningWheelDark: '@'
			},
			replace: true,
			link: spinningWheelLink,
			controller: spinningWheelController
		};
	}

	spinningWheelController.$inject = ['$scope'];

	function spinningWheelLink($scope, element) {
		element.addClass('spinning-wheel');

		if ($scope.isSpinningWheelAfter === 'true') {
			element.addClass('spinning-wheel__display-after');
		} else {
			element.addClass('spinning-wheel__display-before');
		}

		if ($scope.isSpinningWheelDark === 'true') {
			element.addClass('spinning-wheel__dark');
		}

		$scope.$watch(
			() => $scope.isSpinningWheelActive,
			(newValue, oldValue) => {
				if (newValue === true) {
					element.addClass('spinning-wheel__active');
				} else if (newValue === false) {
					element.removeClass('spinning-wheel__active');
				}
			}
		);
	}

	function spinningWheelController($scope) {}
})();



// WEBPACK FOOTER //
// ./web/js/components/spinningWheel.js